import { IconPortal, PrimaryButton } from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import comingSoonCustom from '~/portal/images/consumer/landing-page/coming-soon-custom.svg'
import comingSoonDark from '~/portal/images/consumer/landing-page/coming-soon-dark.svg'
import noContentDark from '~/portal/images/consumer/landing-page/no-content-dark.svg'
import noContent from '~/portal/images/consumer/landing-page/no-content.svg'
import { SWAGGERHUB_ROLE } from '~/shared/types/shub'

const EmptyLandingPage = ({ role, isDark, portalName } : { role?: SWAGGERHUB_ROLE; isDark: boolean; portalName?: string; }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const comingSoonImage = isDark ? comingSoonDark : comingSoonCustom

  if (!role) {
    return (
      <div
        data-testid="empty-landing-page"
        className={clsx(
          'flex items-center h-full pt-[80px] px-[24px] flex-col xl:flex-row',
          'xl:[pl-80px] xl:pr-[40px] xl:pb-[40px]',
          'bg-(--sp-color-surface-sunken) dark:bg-(--sp-color-surface)'
        )}
      >
        <div className="flex flex-col items-center w-full xl:w-auto xl:h-full">
          <div className="my-auto">
            <div
              data-testid="empty-landing-page-portal-name"
              className={clsx(
                'rounded py-1.5 px-6 text-h4 w-fit mx-auto xl:m-0',
                'bg-(--sp-color-surface) text-(--sp-color-text-strong)'
              )}
            >
              {portalName}
            </div>
            <div
              data-testid="empty-landing-page-title"
              className={clsx(
                'text-h1 pt-4 xl:pt-0 xl:text-[4.5rem] xl:leading-[6.75rem] text-center xl:text-left',
                'text-(--sp-color-text-muted)'
              )}
            >{t('consumer.landing.empty.loggedOut.title')}</div>
          </div>
          
        </div>
        <div className="flex flex-col items-center w-full gap-4 xl:w-auto xl:ml-auto pt-[24px] pb-[48px] xl:py-0">
          <img
            src={comingSoonImage}
            alt="no content"
            className="w-[343px] h-[343px] md:w-[400px] md:h-[400px] xl:w-[653px] xl:h-[653px]"
          />
        </div>
      </div>
    )
  }

  return (
    <div className="flex h-full text-center pt-[72px]">
      <div className="flex flex-col items-center mx-auto">
        <img src={isDark ? noContentDark : noContent} width={220} height={140} />
        <div className="mt-10 mb-4 text-h1 text-(--sp-color-text-strong)">{t('consumer.landing.empty.loggedIn.title')}</div>
        <div className="mb-8 text-body1 text-(--sp-color-text-muted)">{t('consumer.landing.empty.loggedIn.description')}</div>
        {role !== SWAGGERHUB_ROLE.CONSUMER ? (
          <div>
            <PrimaryButton size="s" className="w-full" icon={<IconPortal width={16} height={16} />} onClick={() => navigate('/sp-admin/home')}>
              {t('consumer.landing.empty.loggedIn.button.label')}
            </PrimaryButton>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default EmptyLandingPage